var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 639 643"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M491.4 371C487.7 489.2 391 584 271.8 584c-121.5 0-219.9-98.5-219.9-219.9 0-121.5 98.5-219.9 219.9-219.9 33.6 0 65.4 7.8 93.9 21.3l30.8-42.5c-37.4-19.4-79.7-30.5-124.7-30.5C121.8 92.5.1 214.1.1 364.2c0 150 121.6 271.7 271.7 271.7s271.7-121.6 271.7-271.7c0-19.5-2.1-38.4-6-56.7L491.4 371z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M302.8 535.1c5.3 2.4 11.8.7 15.2-4.2L637.3 71.1c3.9-5.6 2.5-13.3-3.1-17.1L559.6 2.2c-5.6-3.9-13.3-2.5-17.1 3.1L292.7 361.7 180.2 250.4c-4.8-4.8-12.6-4.8-17.4 0l-64.2 64.2c-4.8 4.8-4.8 12.6 0 17.4"
  })));
}

export default SvgCheck;